export enum ERROR {
  SOMETHING_WENT_WRONG = 'Something went wrong. Please try again.',
  SIGN_UP_CONFIRMATION_FAILED = 'Something went wrong. Please, try to sign up later',
  SIGN_UP_EMAIL_ALREADY_EXISTS = 'This email is already registered.',
  SIGN_UP_EMAIL_INVALID = 'Enter a valid email address.',
  PASSWORD_RESET_CONFIRMATION_FAILED = 'Something went wrong. Please try resetting your password again.',
}
